<template>
    <div>
        <header class="joy-panel__header">
            <h2 class="step__title">
                <VJoyIcon name="megaphone" />
                {{ $msg('customer.brief.exec.form.industry.expertise.tooltip.title') }}
            </h2>
            <p class="joy-panel__subtitle">
                {{ $msg('customer.brief.exec.form.mission.description.tooltip.suggest') }}
            </p>
        </header>
        <section class="joy-panel__section">
            <header class="joy-panel__header">
                <h2 class="joy-panel__title">
                    {{ $msg('customer.brief.exec.form.mission.description.tooltip.title.context') }}
                </h2>
            </header>
            <ul>
                <li>{{ $msg('customer.brief.exec.form.mission.description.tooltip.context.one') }}</li>
                <li>{{ $msg('customer.brief.exec.form.mission.description.tooltip.context.two') }}</li>
                <li>{{ $msg('customer.brief.exec.form.mission.description.tooltip.context.three') }}</li>
            </ul>
        </section>

        <section class="joy-panel__section">
            <header class="joy-panel__header">
                <h2 class="joy-panel__title">
                    {{ $msg('customer.brief.exec.form.mission.description.tooltip.title.project') }}
                </h2>
            </header>
            <ul>
                <li>{{ $msg('customer.brief.exec.form.mission.description.tooltip.project.one') }}</li>
                <li>{{ $msg('customer.brief.exec.form.mission.description.tooltip.project.two') }}</li>
                <li>{{ $msg('customer.brief.exec.form.mission.description.tooltip.project.three') }}</li>
            </ul>
        </section>

        <section class="joy-panel__section">
            <header class="joy-panel__header">
                <h2 class="joy-panel__title">
                    {{ $msg('customer.brief.exec.form.mission.description.tooltip.title.profile') }}
                </h2>
            </header>
            <ul>
                <li>{{ $msg('customer.brief.exec.form.mission.description.tooltip.profile.one') }}</li>
                <li>{{ $msg('customer.brief.exec.form.mission.description.tooltip.profile.two') }}</li>
            </ul>
        </section>
    </div>
</template>

<script lang="ts"></script>

<style lang="scss" scoped>
    @use '~@malt/joy-entrypoint/src/sass/base/2_mixins/text';

    .joy-panel {
        &__subtitle {
            @include text.getFontBySize(primary-300);
            color: var(--joy-color-neutral-40);
        }

        &__header {
            margin-bottom: 10px;
        }

        &__title {
            @include text.getFontBySize(primary-450);
        }

        &__section {
            .joy-panel__title {
                @include text.getFontBySize(primary-350);
            }
            ul {
                list-style-type: disc;
                padding-left: 20px;
            }
            ul li {
                margin: 8px 0;
                @include text.getFontBySize(primary-300);
            }
        }
    }
</style>
